export enum Sorting {
  CreatedAt = 'CreatedAt',
  Endpoint = 'Endpoint',
  Id = 'Id',
  LastModifiedBy = 'LastModifiedBy',
  ListDependentType = 'ListDependentType',
  ListType = 'ListType',
  MessageMedium = 'MessageMedium',
  Method = 'Method',
  Name = 'Name',
  StartAt = 'StartAt',
  State = 'State',
  UpdatedAt = 'UpdatedAt',
}

export enum SortDirection {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export type SortInput = {
  sortBy?: Sorting;
  sortDirection?: SortDirection;
};
